export interface OpportunitiesLife {
  firstName: string;
  lastName: string;
  email: string;
  dob: string;
  state: string;
  phone: string;
  county: string;
}
